import { pluralizeWithCount } from "@common/helpers/string";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { CommandIslandTotal } from "@design-system/CommandIsland/CommandIslandTotal";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { Pagination } from "@design-system/Pagination/Pagination";
import { Loader } from "@design-system/Loader/Loader";
import { Button } from "@design-system/Button/Button";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { BulkSelectionControl } from "@design-system/BulkSelectionControl/BulkSelectionControl";
import { Shortcut } from "@design-system/Shortcut/Shortcut";
import { HStack } from "@design-system/HStack/HStack";

interface Props {
    total: number;
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
    isLoading?: boolean;
    selectedCount?: number;
    onClearSelection?: () => void;
    onOpenBulkActions?: () => void;
    isBulkActionPending?: boolean;
}

export const InvoiceTemplatesListFooter: React.FC<Props> = ({
    total,
    currentPage,
    totalPages,
    onPageChange,
    isLoading,
    selectedCount = 0,
    onClearSelection,
    onOpenBulkActions,
    isBulkActionPending,
}) => {
    if (!total) {
        return null;
    }

    const hasSelection = selectedCount > 0;

    return (
        <CommandIsland
            sticky
            className={commandIslandStyles.bulkActionsStickyFooter}
        >
            <HStack gap={8}>
                {isLoading ? (
                    <Loader inline delayed />
                ) : (
                    totalPages > 1 && (
                        <Pagination
                            size="md"
                            pageCount={totalPages}
                            currentPage={currentPage}
                            onPageChange={onPageChange}
                        />
                    )
                )}
                <CommandIslandTotal>
                    {pluralizeWithCount("template", total)}
                </CommandIslandTotal>
                {hasSelection && onClearSelection && (
                    <BulkSelectionControl
                        size="md"
                        selectedCount={selectedCount}
                        onClearSelection={onClearSelection}
                    />
                )}
            </HStack>

            {hasSelection && onOpenBulkActions && (
                <Tooltip content="Open bulk actions">
                    <Button
                        variant="primary"
                        size="md"
                        rightIcon={
                            <span data-slot-box="">
                                <Shortcut keys="mod+k" />
                            </span>
                        }
                        onClick={onOpenBulkActions}
                        disabled={isBulkActionPending}
                    >
                        Actions
                    </Button>
                </Tooltip>
            )}
        </CommandIsland>
    );
};
